import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useEventsTableData({
  month,
  zone,
  period,
  event_type,
  enabled = true,
}) {
  const { getEventsTableData } = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: ["eventsTableData", month, zone, period, event_type],
    queryFn: () => getEventsTableData({ month, zone, period, event_type }),
    enabled,
  });

  return { data: data?.data.table_data, isLoading, error };
}
